import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SergasDevice} from './sergasDevice';
import {HardwareDevice} from './hardwareDevice';

@Injectable({
  providedIn: 'root'
})
export class HardwareDeviceService {

  private basePath = "api/v1/sergas_device";

  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  getAllBySergasDevice(sergasDeviceId:string): Promise<any>{
    let url = this.basePath + "/" + sergasDeviceId + "/hardware_device";
    return this.http.get(url)
      .toPromise()
      .then( res => res as HardwareDevice[])
      .catch( error => this.errorHandler(error) );
  }

  updateHardwareDevice(hardwareDevice: HardwareDevice): Promise<any> {
    let url = this.basePath + "/" + hardwareDevice.sergasDeviceId + "/hardware_device/" + hardwareDevice.hardwareDeviceId;
    return this.http.put(url, hardwareDevice)
      .toPromise()
      .then( res => res as HardwareDevice)
      .catch( error => this.errorHandler(error) );
  }
}
